import React from 'react'
import { connect } from 'react-redux'
import { AccessResult, TicketResult, OrderEventResult, ReferenceResult } from 'components/core'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import { ContentHeader, StaticBox, NoContentBox } from 'components/basic'
import axios from 'axios'

const CancelToken = axios.CancelToken
class Search extends FlowView {
  constructor (props) {
    super(props)
    this.state = {
      limit: 10,
      totalResults: null,
      activePage: 0,
      query: props.search.query || '',
      menu: false,
      endpoint: '2.4/accesses/search/',
      search: 'Accesses',
      icon: 'fa-home',
      loading: false
    }
    this.timer = null
    this.cancelToken = CancelToken.source()
  }
  componentWillUnmount () {
    this.clearSearch()
  }
  componentDidMount () {
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Search'
    })
    if (this.props.search.total) this.setState({totalResults: this.props.search.total})
  }
  loadMore () {
    if (this.state.totalResults < this.state.limit) return
    this.setState({limit: this.state.limit + 10, loading: true}, e => {
      this.dispatchQuery(this.props.search.query)
    })
  }
  async dispatchQuery (query) {
    if (query.length === 0) return
    this.cancelToken.cancel()
    let cancelToken = CancelToken.source()
    this.cancelToken = cancelToken
    var err, res
    if (this.state.pathparam) {
      [err, res] = await http.get(this.state.endpoint + query, {detailed: true}, null, { cancelToken: cancelToken.token })
    } else {
      [err, res] = await http.get(this.state.endpoint,
        {
          search: query,
          sortingBy: 'updated',
          sortingOrder: 'desc',
          limit: this.state.limit,
          offset: (this.state.limit * this.state.activePage)
        },
        null,
        {
          cancelToken: cancelToken.token
        }
      )
    }
    const totalResults = err ? 0 : res.headers['x-total-count']
    let data = err ? [] : res.data;
    if (!Array.isArray(data)) data = [data]
    this.setState({loading: false, totalResults: totalResults})
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: query,
        results: data
      }
    })
  }
  handleChange (event) {
    this.setState({loading: true})
    var query = event.target.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.setState({activePage: 0}, e => this.dispatchQuery(query))
    }, 350)
  }
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        results: false
      }
    })
    this.setState({limit: 10, totalResults: 0})
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle='Search' icon='fa-search' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} xs={12} sm={12} icon='search' title='Search'>
            <div className='input-group search'>
              <span className='input-group-addon' onClick={(e) => { this.setState({menu: !this.state.menu}) }}>
                <i className={'fa fa-fw ' + this.state.icon} />
                <div className={'search-index-menu ' + (this.state.menu ? '' : 'hidden')}>
                  <a onClick={() => { this.setState({icon: 'fa-home', endpoint: '2.4/accesses/search/', search: 'Accesses', pathparam: false}, this.clearSearch()) }}><i className='fa fa-fw fa-home' /></a>
                  <a onClick={() => { this.setState({icon: 'fa-handshake-o', endpoint: '2.4/subscriptions/search/', search: 'Reference'}, this.clearSearch()) }}><i className='fa fa-fw fa-handshake-o' /></a>
                  <a onClick={() => { this.setState({icon: 'fa-ticket', endpoint: '2.4/tickets/search/', search: 'Tickets', pathparam: false}, this.clearSearch()) }}><i className='fa fa-fw fa-ticket' /></a>
                  <a onClick={() => { this.setState({icon: 'fa-exchange', endpoint: '2.4/option82/', search: 'Option 82', pathparam: true}, this.clearSearch()) }}><i className='fa fa-fw fa-exchange' /></a>
                  <a onClick={() => { this.setState({icon: 'fa-cog', endpoint: '2.4/orderevents/search/', search: 'Internal Reference'}, this.clearSearch()) }}><i className='fa fa-fw fa-cog' /></a>
                </div>
              </span>
              <input
                ref={el => (this.searchField = el)}
                type='text'
                defaultValue={this.props.search.query}
                onChange={(e) => {
                  this.handleChange(e)
                }}
                onFocus={e => this.setState({fieldFocused: true})}
                onBlur={e => this.setState({fieldFocused: false})}
                className='form-control navbar-search-field'
                placeholder={'Search ' + this.state.search} />
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='list-group flow-search-results full-search-results'>
                  {this.state.loading && this.searchField.value.length !== 0 && <NoContentBox icon='circle-o-notch fa-spin' text='Loading...' /> }
                  {!this.state.loading && this.props.search.results.length === 0 && this.searchField && this.state.fieldFocused && this.searchField.value.length !== 0 && <NoContentBox icon='exclamation' text='No Results' /> }
                  {this.props.search.results && this.props.search.results.map((result, i) => {
                    switch (this.state.search) {
                      case 'Tickets':
                        return <TicketResult clearSearch={e => this.clearSearch()} result={result} key={i} active={(i === this.state.location)} />
                      case 'Reference':
                        return <ReferenceResult clearSearch={e => this.clearSearch()} result={result} key={i} active={(i === this.state.location)} />
                      case 'Accesses':
                        return <AccessResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
                      case 'Internal Reference':
                        return <OrderEventResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
                      default:
                        return <AccessResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
                    }
                  })}

                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 text-center padding-20'>
                {this.props.search.results && !!this.props.search.results.length && !(this.state.totalResults < this.state.limit) &&
                  <button onClick={e => this.loadMore()} className='btn btn-primary'>{this.state.loading ? <i className='fa fa-spin fa-spinner' /> : 'Load ' + (this.state.totalResults ? this.state.totalResults - this.props.search.results.length : '') + ' more results'}</button>
                }
              </div>
            </div>
          </StaticBox>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
Search = connect(state => state.siteReducer)(Search)
export default Search



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/search.js